import { DELETE_PRODUCT, DELETE_PRODUCT_FAILED, DELETE_PRODUCT_SUCCEEDED, DeleteProductActionTypes } from "./actionTypes";
import { ProductManagementState } from "../../configuration/state";

const initialState: ProductManagementState = {
    loading: false,
    success: undefined,
    error  : undefined,
}

export const deleteProductReducer = (state = initialState, action: DeleteProductActionTypes): ProductManagementState => {
    switch (action.type) {
        case DELETE_PRODUCT:
            return {
                loading: true,
                success: undefined,
                error  : undefined,
            }
        case DELETE_PRODUCT_SUCCEEDED:
            return {
                loading: false,
                success: true,
                error  : undefined
            }
        case DELETE_PRODUCT_FAILED:
            return {
                loading: false,
                success: false,
                error  : action.payload
            }
        default:
            return state
    }
}
